import { render, staticRenderFns } from "./GalleryUploadPhoto.vue?vue&type=template&id=c2480fa4"
import script from "./GalleryUploadPhoto.vue?vue&type=script&lang=js"
export * from "./GalleryUploadPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports